import { faker } from '@faker-js/faker'

import { HospitalCountry } from '../../contracts/hospital'
import { Language } from '../../contracts/performance-ad'
import { Currency } from '../../contracts/service-offer'
import {
  ServiceOfferBadge,
  UserServiceOfferInHospitalFilteredListView,
  UserServiceOfferInHospitalListItem,
} from '../../contracts/service-offer/UserServiceOfferInHospitalFilteredListView'
import { OperationType } from '../../contracts/treatment'
import { asBuilder } from '../asBuilder'

export const getUserServiceOfferInHospitalListItem = asBuilder((): UserServiceOfferInHospitalListItem => {
  return {
    id: faker.number.int(),
    title: faker.lorem.text(),
    thumbnail: faker.image.url(),
    targetLanguage: faker.helpers.enumValue(Language),
    operationType: faker.helpers.enumValue(OperationType),
    price: {
      originalAmount: faker.number.int(),
      discountedAmount: faker.number.int(),
      discountPercentage: faker.number.int(),
      currency: faker.helpers.enumValue(Currency),
      exchangeRateAppliedPrice: {
        originalAmount: faker.number.int(),
        discountedAmount: faker.number.int(),
        currency: faker.helpers.enumValue(Currency),
      },
    },
    includeVat: faker.datatype.boolean(),
    rating: {
      totalRating: faker.number.float({ min: 0, max: 10, precision: 0.1 }),
      ratingCount: faker.number.int(),
    },
    badges: faker.helpers.multiple(() => faker.helpers.enumValue(ServiceOfferBadge)),
    medicalCasesCount: faker.number.int(),
    hospital: {
      id: faker.number.int(),
      name: faker.lorem.word(),
      country: faker.helpers.enumValue(HospitalCountry),
    },
  }
})
export const getUserServiceOfferInHospitalFilteredListView = asBuilder(
  (): UserServiceOfferInHospitalFilteredListView => {
    return {
      contents: faker.helpers.multiple(() => getUserServiceOfferInHospitalListItem()),
      totalPageNumber: faker.number.int(),
      currentPageIndex: faker.number.int(),
      pageSize: faker.number.int(),
      isLastPage: faker.datatype.boolean(),
      totalElementNumber: faker.number.int(),
    }
  },
)
